module.exports = __webpack_public_path__ + "img/t.747408d0.png";